import React from "react";
import HomeSlider from "../components/HomeSlider";
import HomeAbout from "../components/HomeAbout";
import "./Home.css";
import pic1 from "../assets/founderelizabeth.jpg";
import pic2 from "../assets/founderdaniel.jpg";

const Home = () => {
  return (
    <>
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLSelRyTBI6DCtqYluwqVay8A2Fy5d55VcXAnI-n2-t76ccSc4g/viewform?pli=1&pli=1"
        target="_blank"
        rel="noopener noreferrer"
      >
        {/* Notification banner commented out */}
      </a>

      <HomeSlider />
      <HomeAbout />

      <div className="founders-section">
        <h1 className="founders-section-title">From the Founders</h1>
        <div className="founders-section-divider"></div>
        
        <div className="founders-section-cards">
          {/* Card 1 */}
          <div className="founders-section-card-1">
            <div className="founders-section-card-top">
              <img
                src={pic1}
                alt=""
                className="founders-section-card-image"
              /> 
              <h1 className="founders-section-card-name">
                Elizabeth Sterling
              </h1>
            </div>

            <div className="founders-section-card-bot">
              <div className="founders-section-card-bot-quote-1">
                {" "}
                "You are always one decision away from changing the rest of your life."
              </div>
              <div className="founders-section-card-bot-fluff-1">
                {" "}
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="founders-section-card-2">
            <div className="founders-section-card-top">
              <h1 className="founders-section-card-name">
                Daniel Badell
              </h1>
              <img
                src={pic2}
                alt=""
                className="founders-section-card-image"
              />
            </div>

            <div className="founders-section-card-bot">
              <div className="founders-section-card-bot-quote-2">
                {" "}
                "Sometimes impact isn’t loud. Sometimes it’s just making sure one person doesn’t have to do it alone."
              </div>
              <div className="founders-section-card-bot-fluff-2">
                {" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;